import { Injectable, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

import { StatusModel } from 'shared/search/status.model';


@Injectable()
export class FitmentsScorecardService {

  // when user clicks on status in the scorecard we have to filter results by selected status
  @Output() statusFilterChanged: EventEmitter<StatusModel|null> = new EventEmitter<StatusModel|null>();

}
